.actions {
  display: flex;
  gap: 2.4rem;
  align-items: center;
  margin-top: 4rem;
}

.field {
  display: flex;
  gap: 2.4rem;
  align-items: flex-end;
}

.loaderIcon {
  flex-shrink: 0;
  margin-bottom: 1.2rem;
  color: var(--color-shadow-green);
}
